export default "__VITE_ASSET__BBgvXiuO__"